<template>
  <ul class="course-categories">
    <b-collapse animation="" :open="true" aria-id="right-categories-list">
      <li @click="open" class="list_header categories active" slot="trigger" aria-controls="right-categories-list">
        <span class="left"> <i class="icon-button-arrow"></i>Категории курсов </span>
      </li>
     <b-collapse
        @open="loadCourses(category.id)"
        animation=""
        v-for="(category, i) in CategoriesList"
        :key="i"
        :open="false"
        :aria-id="'categories-item-' + i"
      >
        <li 
          @click="open" 
          class="list_header category" 
          slot="trigger" 
          :aria-controls="'categories-item-' + i"
        >
          <span class="left"> <i class="mdi mdi-plus"></i><i class="mdi mdi-minus"></i>{{ category.name }} </span>
        </li>
        <div v-if="!CourseAdd">
          <li :key="course.name + j" class="list_item active course" v-for="(course, j) in category.courses">
            <router-link
              :to="
                userRole === 'leader'
                  ? '/courses/' + course.id
                  : course.status
                  ? '/all-courses/course-statistic/' + course.id
                  : '/all-courses/create/' + course.id
              "
            >
              <span class="left">
                {{ course.name }}
              </span>
            </router-link>
          </li>
          <li
            v-if="category.courses && category.courses.length < category.totalCourses"
            class="list_item load"
            @click="loadCourses(category.id, Number(category.courses.length / 15) + 1)"
          >
            <span class="left">
              Загрузить ещё
            </span>
          </li>
        </div>
        <div v-if="CourseAdd">
          <li :key="course.name + j" class="list_header course" v-for="(course, j) in category.courses">
            <span class="right">
              <b-field class="input_checkbox">
                  <b-checkbox
                    :disabled="course.id === -1 || isCourseinUserCourses(course.id)"
                    v-model="CheckedCourses.ids"
                    :native-value="course.id"
                    type="is-info"
                    :class="(course.id === -1 || isCourseinUserCourses(course.id)) ? 'no-box' : ''"
                    >{{ course.name }}</b-checkbox
                  >
                </b-field>
            </span>
          </li>
          <!-- <b-pagination
            :total="category.totalCourses || 1"
            :current="category.page"
            :simple="true"
            :size="'is-small'"
            :order="'is-right'"
            @change="loadCourses(category.id, $event)"
            :per-page="15">
          </b-pagination> -->
        </div>
      </b-collapse>
    </b-collapse>
  </ul>
</template>

<script>
export default {
  props: {
    CategoriesList: {
      default: () => [],
      type: Array
    },
    CourseAdd: {
      default: () => false,
      type: Boolean
    },
    CheckedCourses: {
      default: () => {},
      type: Object
    },
    UserCourses: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      openedCategory: null
    }
  },
  methods: {
    filteredCourses(array) {
      if (!array) {
        return []
      }
      if (this.$route.name === 'all-users_id' || this.$route.name === 'users_id') {
        return array.filter(
          (course) =>
            this.branchInfo.courses.some((el) => el.id === course.id) &&
            !this.userInfo.courses.some((el) => el.id === course.id)
        )
      }
      if (this.$route.name === 'branches_id') {
        let coursesList = array.filter((course) => !this.branchInfo.courses.some((el) => el.id === course.id))
        if (coursesList.length) {
          return coursesList
        }
        return [{ name: 'Все курсы назначены', id: -1 }]
      }
    },
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    },
    loadCourses(categoryId, page = 1) {
      if (this.userRole === 'leader' && this.branchInfo.id !== this.profileInfo.branch.id) {
        this.$axios2
          .get('branches/' + this.profileInfo.branch.id)
          .then((resp) => {
            this.$store.commit('setBranchInfo', { list: resp.data })
          })
          .catch(this.$errorToast)
      }
      const data = this.$store.state.categories.categoriesList
      const currentCategoryIndex = data.findIndex((el) => el.id === categoryId)
      if (data[currentCategoryIndex].courses.length > 0 && page === 0) {
        return
      }
      this.openedCategory = categoryId

      this.$axios2
        .get('courses/list?category_id=' + categoryId + '&page=' + (page - 1))
        .then((resp) => {
          this.$store.commit('setCategoryCoursesList', { 
            list: resp.data, 
            page, 
            index: currentCategoryIndex 
          })
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    isCourseinUserCourses(id){
      return this.UserCourses.find(el => el.id === id) ? true : false
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    userInfo() {
      return this.$store.state.allUsers.UserInfo
    },
    branchInfo() {
      return this.$store.state.branches.branchInfo
    }
  }
}
</script>
